import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconAccess, IconAlarm, IconWarn, IconZoom } from '@assets/images/main';
import { rtlsSystem2 } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionEquipment/video/rtlsVideo.mp4';
import subVideo1 from '@src/assets/images/solution/constructionEquipment/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/constructionEquipment/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/constructionEquipment/video/sub/rtlsVideo3.mp4';

export default {
  banner: {
    title: 'Quản lý thiết bị hạng nặng',
    desc: 'Thiết bị hạng nặng là yếu tố then chốt tại công trường xây dựng. Do đó, việc bảo trì đúng cách và phòng ngừa tai nạn là điều bắt buộc. Nếu được quản lý đúng cách, thiết bị hạng nặng sẽ giúp duy trì an toàn, giảm chi phí và nâng cao rõ rệt năng suất tại công trường.',
  },

  video: {
    title: 'Giải pháp thông minh nhất để quản lý thiết bị hạng nặng.',
    desc: 'Theo dõi vị trí thiết bị hạng nặng tại công trường theo thời gian thực.<br/>Phòng tránh va chạm và tối ưu bố trí để <strong>nâng cao hiệu quả và năng suất</strong> quy trình làm việc.',
    play: video,
  },

  func: [
    {
      title: 'Theo dõi vị trí thời gian thực',
      desc: 'Theo dõi vị trí hiện tại của thiết bị hạng nặng theo thời gian thực. Nhờ đó, có thể bố trí thiết bị một cách hiệu quả tại công trường và quản lý thời gian trở nên dễ dàng hơn.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh chóng',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: 'Hệ thống cảnh báo tiếp cận gần',
      desc: 'Trong quá trình vận hành thiết bị hạng nặng, nếu xảy ra tai nạn do lỗi con người hoặc sự cố hệ thống, hậu quả có thể rất nghiêm trọng. Đặc biệt, va chạm với con người là cực kỳ nguy hiểm. Hệ thống cho phép giám sát theo thời gian thực và phản ứng kịp thời khi có sự cố.',
      sub1: 'Chỉ định đối tượng nguy hiểm',
      icon1: IconWarningGray,
      sub2: 'Thiết lập khoảng cách cảnh báo',
      icon2: IconRulerGray,
      video: subVideo2,
    },
    {
      title: 'Phát hiện nguy hiểm tại điểm mù',
      desc: 'Người vận hành thiết bị nặng có thể gặp phải các điểm mù trong tầm nhìn. Công việc có mức độ mệt mỏi cao dễ tạo ra môi trường khiến con người lơ là, mất cảnh giác. Do đó, việc xác định các điểm mù giúp phòng ngừa rủi ro va chạm với người và duy trì một môi trường làm việc an toàn tại hiện trường.',
      sub1: 'Thiết lập phạm vi linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      video: subVideo3,
    },
  ],

  subfunc: {
    title: 'Tính năng đa dạng',
    desc: 'Thiết bị nặng đóng vai trò then chốt tại công trường, xét trên cả phương diện an toàn và hiệu quả chi phí. Việc sử dụng thiết bị nặng không tuân thủ quy định an toàn có thể dẫn đến tai nạn, trong khi các phương thức vận hành kém hiệu quả gây lãng phí chi phí và nhân lực. Để kiến tạo một môi trường làm việc vừa an toàn vừa kinh tế, Orbro đã phát triển các nhóm tính năng chuyên biệt sau đây.',
    data: [
      {
        icon: IconChartRadius,
        title: 'Báo cáo và phân tích',
        desc: 'Có thể tạo báo cáo và tài liệu phân tích dựa trên dữ liệu thu thập từ công trường.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo theo thời gian thực',
        desc: 'Khi xảy ra tình huống bất thường về thiết bị nặng, hệ thống sẽ gửi cảnh báo để có thể ứng phó kịp thời.',
      },
      {
        icon: IconRoute,
        title: 'Truy xuất lịch sử di chuyển',
        desc: 'Xem lại đường đi và thời gian di chuyển của thiết bị.',
      },
      {
        icon: IconDashboard,
        title: 'Nắm bắt hiện trạng',
        desc: 'Xác định vị trí hiện tại và trạng thái di chuyển của từng thiết bị.',
      },
      {
        icon: IconWarning,
        title: 'Phát hiện rời khỏi khu vực',
        desc: 'Cảnh báo khi thiết bị rời khỏi khu vực cho phép.',
      },
      {
        icon: IconSearch,
        title: 'Phân tích mô hình lộ trình di chuyển',
        desc: 'Phân tích mức độ sử dụng thiết bị nặng tại công trường và thời điểm chúng được sử dụng.',
      },
      {
        icon: IconChainLink,
        title: 'Tích hợp dữ liệu',
        desc: 'Kết nối hiệu quả với các hệ thống như RFID, IoT, an ninh và camera.',
      },
      {
        icon: IconSecurity,
        title: 'Bảo mật dữ liệu',
        desc: 'Duy trì mức độ bảo mật dữ liệu cao, đảm bảo cung cấp giải pháp có độ tin cậy vượt trội.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem2,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'carPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionSafety' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
